import { useState, useEffect } from "react";

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController } from "context";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "../../../components/MDBox";
import MDModal from "../../../components/MDModal";
import MDTypography from "../../../components/MDTypography";
import MDButton from "../../../components/MDButton";

import { getSuppliers, postSupplier, putSupplier } from "../../../api/suppliers";

import PropTypes from "prop-types";

import { setAllSuppliers } from "../../../redux/reducers/suppliersReducer";
import { useDispatch } from "react-redux";

import SupplierInfo from "./SupplierInfo";

export default function CreateEditSupplier({
  suppliers,
  fetchSuppliersWithFilters,
  supplier = null,
  edit = false,
}) {
  const [open, setOpen] = useState(false);

  const [supplierId, setSupplierId] = useState("");
  const [supplierName, setSupplierName] = useState("");
  const [ascenseurDeCharge, setAscenseurDeCharge] = useState(0);
  const [ascenseur, setAscenseur] = useState(0);
  const [epmr, setEpmr] = useState(0);
  const [chaise, setChaise] = useState(0);
  const [monteChargeAccessible, setMonteChargeAccessible] = useState(0);
  const [monteChargeInaccessible, setMonteChargeInaccessible] = useState(0);
  const [porteGarage, setPorteGarage] = useState(0);
  const [portePietonne, setPortePietonne] = useState(0);
  const [porteSouple, setPorteSouple] = useState(0);
  const [monteFut, setMonteFut] = useState(0);
  const [monteVoiture, setMonteVoiture] = useState(0);
  const [plateformeDeCharge, setPlateformeDeCharge] = useState(0);
  const [plateformeEscalier, setPlateformeEscalier] = useState(0);
  const [plaqueTournante, setPlaqueTournante] = useState(0);
  const [monteMalade, setMonteMalade] = useState(0);
  const [montePalette, setMontePalette] = useState(0);
  const [portillon, setPortillon] = useState(0);
  const [rideau, setRideau] = useState(0);
  const [autreFermeture, setAutreFermeture] = useState(0);
  const [barriereLevante, setBarriereLevante] = useState(0);
  const [portailBattant, setPortailBattant] = useState(0);
  const [barriere, setBarriere] = useState(0);
  const [porte, setPorte] = useState(0);
  const [portail, setPortail] = useState(0);
  const [porteDeQuai, setPorteDeQuai] = useState(0);
  const [porteSectionnelle, setPorteSectionnelle] = useState(0);
  const [rideauMetallique, setRideauMetallique] = useState(0);
  const [borneEscamotable, setBorneEscamotable] = useState(0);
  const [interphone, setInterphone] = useState(0);
  const [porteVitree, setPorteVitree] = useState(0);
  const [portailCoulissant, setPortailCoulissant] = useState(0);
  const [quaiNiveleur, setQuaiNiveleur] = useState(0);

  const dispatch = useDispatch();

  useEffect(() => {
    if (edit && supplier) {
      setSupplierId(supplier.supplier_id);
      setSupplierName(supplier.supplier_name);
      setAscenseurDeCharge(supplier.ascenseur_de_charge);
      setAscenseur(supplier.ascenseur);
      setEpmr(supplier.epmr);
      setChaise(supplier.chaise);
      setMonteChargeAccessible(supplier.monte_charge_accessible);
      setMonteChargeInaccessible(supplier.monte_charge_inaccessible);
      setPorteGarage(supplier.porte_garage);
      setPortePietonne(supplier.porte_pietonne);
      setPorteSouple(supplier.porte_souple);
      setMonteFut(supplier.monte_fut);
      setMonteVoiture(supplier.monte_voiture);
      setPlateformeDeCharge(supplier.plateforme_de_charge);
      setPlateformeEscalier(supplier.plateforme_escalier);
      setPlaqueTournante(supplier.plaque_tournante);
      setMonteMalade(supplier.monte_malade);
      setMontePalette(supplier.monte_palette);
      setPortillon(supplier.portillon);
      setRideau(supplier.rideau);
      setAutreFermeture(supplier.autre_fermeture);
      setBarriereLevante(supplier.barriere_levante);
      setPortailBattant(supplier.portail_battant);
      setBarriere(supplier.barriere);
      setPorte(supplier.porte);
      setPortail(supplier.portail);
      setPorteDeQuai(supplier.porte_de_quai);
      setPorteSectionnelle(supplier.porte_sectionnelle);
      setRideauMetallique(supplier.rideau_metallique);
      setBorneEscamotable(supplier.borne_escamotable);
      setInterphone(supplier.interphone);
      setPorteVitree(supplier.porte_vitree);
      setPortailCoulissant(supplier.portail_coulissant);
      setQuaiNiveleur(supplier.quai_niveleur);
    }
  }, [edit, supplier]);

  async function createSupplierAPI() {
    const supplier = {
      supplier_name: supplierName,
      ascenseur_de_charge: ascenseurDeCharge,
      ascenseur: ascenseur,
      epmr: epmr,
      chaise: chaise,
      monte_charge_accessible: monteChargeAccessible,
      monte_charge_inaccessible: monteChargeInaccessible,
      porte_garage: porteGarage,
      porte_pietonne: portePietonne,
      porte_souple: porteSouple,
      monte_fut: monteFut,
      monte_voiture: monteVoiture,
      plateforme_de_charge: plateformeDeCharge,
      plateforme_escalier: plateformeEscalier,
      plaque_tournante: plaqueTournante,
      monte_malade: monteMalade,
      monte_palette: montePalette,
      portillon: portillon,
      rideau: rideau,
      autre_fermeture: autreFermeture,
      barriere_levante: barriereLevante,
      portail_battant: portailBattant,
      barriere: barriere,
      porte: porte,
      portail: portail,
      porte_de_quai: porteDeQuai,
      porte_sectionnelle: porteSectionnelle,
      rideau_metallique: rideauMetallique,
      borne_escamotable: borneEscamotable,
      interphone: interphone,
      porte_vitree: porteVitree,
      portail_coulissant: portailCoulissant,
      quai_niveleur: quaiNiveleur,
    };
    await postSupplier(supplier);
  }

  async function updateSupplierAPI() {
    const supplier = {
      supplier_name: supplierName,
      ascenseur_de_charge: ascenseurDeCharge,
      ascenseur: ascenseur,
      epmr: epmr,
      chaise: chaise,
      monte_charge_accessible: monteChargeAccessible,
      monte_charge_inaccessible: monteChargeInaccessible,
      porte_garage: porteGarage,
      porte_pietonne: portePietonne,
      porte_souple: porteSouple,
      monte_fut: monteFut,
      monte_voiture: monteVoiture,
      plateforme_de_charge: plateformeDeCharge,
      plateforme_escalier: plateformeEscalier,
      plaque_tournante: plaqueTournante,
      monte_malade: monteMalade,
      monte_palette: montePalette,
      portillon: portillon,
      rideau: rideau,
      autre_fermeture: autreFermeture,
      barriere_levante: barriereLevante,
      portail_battant: portailBattant,
      barriere: barriere,
      porte: porte,
      portail: portail,
      porte_de_quai: porteDeQuai,
      porte_sectionnelle: porteSectionnelle,
      rideau_metallique: rideauMetallique,
      borne_escamotable: borneEscamotable,
      interphone: interphone,
      porte_vitree: porteVitree,
      portail_coulissant: portailCoulissant,
      quai_niveleur: quaiNiveleur,
    };
    await putSupplier(supplier, supplierId);
  }

  function resetData() {
    setSupplierId("");
    setSupplierName("");
    setAscenseurDeCharge(0);
    setAscenseur(0);
    setEpmr(0);
    setChaise(0);
    setMonteChargeAccessible(0);
    setMonteChargeInaccessible(0);
    setPorteGarage(0);
    setPortePietonne(0);
    setPorteSouple(0);
    setMonteFut(0);
    setMonteVoiture(0);
    setPlateformeDeCharge(0);
    setPlateformeEscalier(0);
    setPlaqueTournante(0);
    setMonteMalade(0);
    setMontePalette(0);
    setPortillon(0);
    setRideau(0);
    setAutreFermeture(0);
    setBarriereLevante(0);
    setPortailBattant(0);
    setBarriere(0);
    setPorte(0);
    setPortail(0);
    setPorteDeQuai(0);
    setPorteSectionnelle(0);
    setRideauMetallique(0);
    setBorneEscamotable(0);
    setInterphone(0);
    setPorteVitree(0);
    setPortailCoulissant(0);
    setQuaiNiveleur(0);
  }

  async function fetchSuppliers() {
    const response = await getSuppliers();
    const formatedSuppliers = await response.data.map((supplier) => ({
      label: supplier.supplier_name,
      id: supplier.supplier_id,
    }));
    dispatch(setAllSuppliers(formatedSuppliers));
  }

  async function submit() {
    if (edit) {
      await updateSupplierAPI();
      await fetchSuppliersWithFilters();
      await fetchSuppliers();
    } else {
      await createSupplierAPI();
      await fetchSuppliersWithFilters();
      await fetchSuppliers();
      resetData();
    }
    setStep(0);
    setOpen(false);
  }

  async function cancel() {
    if (edit) {
      await fetchSuppliersWithFilters();
      await fetchSuppliers();
    } else {
      resetData();
    }
    setStep(0);
    setOpen(false);
  }

  const [step, setStep] = useState(0);
  const steps = ["Information du fournisseur"];
  const isLastStep = step === steps.length - 1;

  const next = () => setStep(step + 1);
  const previous = () => setStep(step - 1);

  function getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        return (
          <SupplierInfo
            supplierName={supplierName}
            setSupplierName={setSupplierName}
            ascenseurDeCharge={ascenseurDeCharge}
            setAscenseurDeCharge={setAscenseurDeCharge}
            ascenseur={ascenseur}
            setAscenseur={setAscenseur}
            epmr={epmr}
            setEpmr={setEpmr}
            chaise={chaise}
            setChaise={setChaise}
            monteChargeAccessible={monteChargeAccessible}
            setMonteChargeAccessible={setMonteChargeAccessible}
            monteChargeInaccessible={monteChargeInaccessible}
            setMonteChargeInaccessible={setMonteChargeInaccessible}
            porteGarage={porteGarage}
            setPorteGarage={setPorteGarage}
            portePietonne={portePietonne}
            setPortePietonne={setPortePietonne}
            portail={portail}
            setPortail={setPortail}
            porteSouple={porteSouple}
            setPorteSouple={setPorteSouple}
            monteFut={monteFut}
            setMonteFut={setMonteFut}
            monteVoiture={monteVoiture}
            setMonteVoiture={setMonteVoiture}
            plateformeDeCharge={plateformeDeCharge}
            setPlateformeDeCharge={setPlateformeDeCharge}
            plateformeEscalier={plateformeEscalier}
            setPlateformeEscalier={setPlateformeEscalier}
            plaqueTournante={plaqueTournante}
            setPlaqueTournante={setPlaqueTournante}
            monteMalade={monteMalade}
            setMonteMalade={setMonteMalade}
            montePalette={montePalette}
            setMontePalette={setMontePalette}
            portillon={portillon}
            setPortillon={setPortillon}
            rideau={rideau}
            setRideau={setRideau}
            autreFermeture={autreFermeture}
            setAutreFermeture={setAutreFermeture}
            barriereLevante={barriereLevante}
            setBarriereLevante={setBarriereLevante}
            portailBattant={portailBattant}
            setPortailBattant={setPortailBattant}
            barriere={barriere}
            setBarriere={setBarriere}
            porte={porte}
            setPorte={setPorte}
            porteDeQuai={porteDeQuai}
            setPorteDeQuai={setPorteDeQuai}
            porteSectionnelle={porteSectionnelle}
            setPorteSectionnelle={setPorteSectionnelle}
            rideauMetallique={rideauMetallique}
            setRideauMetallique={setRideauMetallique}
            borneEscamotable={borneEscamotable}
            setBorneEscamotable={setBorneEscamotable}
            interphone={interphone}
            setInterphone={setInterphone}
            porteVitree={porteVitree}
            setPorteVitree={setPorteVitree}
            portailCoulissant={portailCoulissant}
            setPortailCoulissant={setPortailCoulissant}
            quaiNiveleur={quaiNiveleur}
            setQuaiNiveleur={setQuaiNiveleur}
          />
        );
      default:
        return null;
    }
  }

  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  return (
    <>
      {edit ? (
        <MDButton
          variant="contained"
          size="small"
          onClick={() => setOpen(true)}
          color={darkMode ? "white" : "dark"}
          sx={{
            width: 170,
            padding: "6px 0 !important",
            height: 40,
            color: !darkMode ? "white" : "#1A2035",
            boxShadow:
              darkMode &&
              "0rem 0.1875rem 0.1875rem 0rem rgba(255, 255, 255, 0.15), 0rem 0.1875rem 0.0625rem -0.125rem rgba(255, 255, 255, 0.2), 0rem 0.0625rem 0.3125rem 0rem rgba(255, 255, 255, 0.15)",
            "&:hover": {
              boxShadow:
                darkMode &&
                "0rem 0.875rem 1.625rem -0.75rem rgba(255, 255, 255, 0.4), 0rem 0.25rem 1.4375rem 0rem rgba(255, 255, 255, 0.15), 0rem 0.5rem 0.625rem -0.3125rem rgba(255, 255, 255, 0.2)",
            },
          }}
        >
          Gérer le fournisseur
        </MDButton>
      ) : (
        <MDButton
          variant="contained"
          sx={{
            height: 53.13,
            width: "100%",
            color: !darkMode ? "white" : "#1A2035",
            boxShadow:
              darkMode &&
              "0rem 0.1875rem 0.1875rem 0rem rgba(255, 255, 255, 0.15), 0rem 0.1875rem 0.0625rem -0.125rem rgba(255, 255, 255, 0.2), 0rem 0.0625rem 0.3125rem 0rem rgba(255, 255, 255, 0.15)",
            "&:hover": {
              boxShadow:
                darkMode &&
                "0rem 0.875rem 1.625rem -0.75rem rgba(255, 255, 255, 0.4), 0rem 0.25rem 1.4375rem 0rem rgba(255, 255, 255, 0.15), 0rem 0.5rem 0.625rem -0.3125rem rgba(255, 255, 255, 0.2)",
            },
          }}
          color={darkMode ? "white" : "dark"}
          size="large"
          onClick={() => setOpen(true)}
        >
          Ajouter un fournisseur
        </MDButton>
      )}
      <MDModal open={open} onClose={() => setOpen(false)}>
        <MDBox mt={25} mb={9}>
          <Grid container justifyContent="center">
            <Grid item xs={12} lg={8}>
              <Card>
                <MDBox
                  mt={-5}
                  mb={2}
                  mx={2}
                  variant="gradient"
                  sx={{
                    background: darkMode ? "white" : "linear-gradient(195deg, #364c70, #273956)",
                    boxShadow: darkMode ? "0 1px 6px 1px white" : "0 1px 6px 1px #344767",
                  }}
                  borderRadius="lg"
                  textAlign="center"
                >
                  <MDBox mt={2} mb={2}>
                    <MDBox>
                      {edit ? (
                        <MDTypography
                          variant="h3"
                          fontWeight="bold"
                          color={darkMode ? "inherit" : "white"}
                        >
                          Modification du fournisseur
                        </MDTypography>
                      ) : (
                        <MDTypography
                          variant="h3"
                          fontWeight="bold"
                          color={darkMode ? "inherit" : "white"}
                        >
                          Ajout d'un nouveau fournisseur
                        </MDTypography>
                      )}
                    </MDBox>
                    <MDTypography
                      variant="h5"
                      fontWeight="regular"
                      color={darkMode ? "inherit" : "white"}
                    >
                      Veuillez entrer les informations relatives au nouveau fournisseur
                    </MDTypography>
                  </MDBox>
                </MDBox>
                <MDBox p={2}>
                  <MDBox>
                    {getStepContent(step)}
                    <MDBox mt={3} width="100%" display="flex" justifyContent="space-between">
                      {step === 0 ? (
                        <MDBox />
                      ) : (
                        <MDButton variant="gradient" color="warning" onClick={previous}>
                          Précédent
                        </MDButton>
                      )}
                      <MDBox textAlign="right">
                        <Grid container spacing={1.5}>
                          <Grid item>
                            <MDButton
                              variant="gradient"
                              color="warning"
                              onClick={cancel}
                              sx={{ marginRight: 2 }}
                            >
                              Annuler
                            </MDButton>
                          </Grid>
                          <Grid item>
                            <MDButton
                              variant="gradient"
                              color="success"
                              onClick={!isLastStep ? next : submit}
                            >
                              {isLastStep ? "Envoyer" : "Suivant"}
                            </MDButton>
                          </Grid>
                        </Grid>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </MDModal>
    </>
  );
}

CreateEditSupplier.propTypes = {
  edit: PropTypes.bool.isRequired,
};
